import React from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { ANONYMOUS_ROUTES } from "../../Constants";
import LoginRegisterPage from "./LoginRegister";
import UpdatePasswordPage from "./UpdatePassword/UpdatePasswordPage";

const AuthenticationRouter = () => {
    return (
        <BrowserRouter basename='/multi-match'>
            <Switch>
                <Route path={ANONYMOUS_ROUTES.UPDATE_PASSWORD} component={UpdatePasswordPage} />
                <Route path={ANONYMOUS_ROUTES.AUTH} component={LoginRegisterPage} />
                <Redirect from='/' to={ANONYMOUS_ROUTES.SIGN_IN} />
            </Switch>
        </BrowserRouter>
    );
};

export default AuthenticationRouter;
